var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header"},[_c('div',{staticClass:"app-header__container container"},[_c('this-nav'),_c('this-start'),_c('this-profile')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }